import createEnum from 'lib/createEnum';

export const Communicators = createEnum('AGENT', 'CUSTOMER');
